module.exports = __webpack_public_path__ + "assets/img/tentacle-hit.deb9eac0.png";